//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'vant/lib/toast/style'
import { Toast } from 'vant'
import { drugToolCollect, drugToolCollectYsz } from './../../../server/home/index'
import Encode from '../../../server/api/encode'
import sa from 'sa-sdk-javascript'
import { mapGetters, mapState } from 'vuex'
import store from '../../../store'

export default {
  components: {
    [Toast.name]: Toast
  },
  props: {
    title: {
      type: String
    },
    isCollect: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hasCollected: 0
    }
  },
  computed: {
    ...mapGetters([
      'uid',
      'isApp',
      'isWeChat',
      'platform',
      'version',
      'guid',
      'system'
    ])
  },
  mounted () {
    // shareItemClick_Success_CB(this.handleShareSuccess)
  },
  methods: {
    // 跳转
    linkTo () {
      history.back()
      closeView()
    },
    /** 公式收藏 、 取消收藏 */
    async collectFormula () {
      let self = this
      let urlData = self.$route.query
      if (!self.hasCollected) {
        sa.track('v1_tool_detailOperate', {
          tool_contentID: urlData.id,
          tool_contentName: this.title,
          tool_contentType: '医学公式详情页',
          tool_operateAction: '收藏'
        })
      }
      if (
        !localStorage.getItem('token') ||
        localStorage.getItem('token') == ''
      ) {
        console.log('这里');
        let a = Encode.encodeFunc('login_main')
        let obj = {
          url: 'https://tool.yxj.org.cn/app/' + a.data
        }
        goPage(obj, (token) => {
          sa.registerPage({
            tool_isAnonymousVisitor: false
          })
          localStorage.setItem('token', token)
          store.commit('editLoginStatus')
        })
        return
      }
      let params = {
        // 0 取消 1 收藏
        collectType: 'FORMULA', // 类型【 1:药品;2:临床指南;3:医学公式;4:资讯】
        status: self.hasCollected ? 0 : 1,
        contentType: 0,
        uuid: urlData.id
      }
      let isYsz = navigator.userAgent.indexOf('ysz') > -1
      if (isYsz) {
        let obj = {
          collected: self.hasCollected ? 0 : 1,
          list: [
            {
              type: 2, // 类型【0-临床指南,1-用药助手,2-医学公式 3-新药】
              typeId: urlData.formulaId ? urlData.formulaId : urlData.id// 类型id
            }
          ]
        }
        drugToolCollectYsz(obj)
          .then((res) => {
            self.hasCollected = !self.hasCollected
            let msg = self.hasCollected ? '收藏成功，可到我的页面-收藏查看' : '取消收藏'
            Toast(msg)
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        drugToolCollect(params)
          .then((res) => {
            self.hasCollected = !self.hasCollected
            let msg = self.hasCollected ? '收藏成功，可到我的页面-收藏查看' : '取消收藏'
            Toast(msg)
          })
          .catch((err) => {
            if (err.status == 401) {
              let encodeStr = Encode.encodeFunc('login_main')
              let obj = {
                url: 'https://tool.yxj.org.cn/app/' + encodeStr.data
              }
              goPage(obj, (token) => {
                sa.registerPage({
                  tool_isAnonymousVisitor: false
                })
                localStorage.setItem('token', token)
                store.commit('editLoginStatus')
              })
            }
          })
      }
    }
  },
  watch: {
    isCollect: {
      handler: function (newValue) {
        let self = this
        self.hasCollected = newValue
      },
      immediate: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/layout/components/header.vue